module.exports = __webpack_public_path__ + "img/pew_33_halo.700b178d.png";